import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const conditionsSelector = (state: RootState) => state.amwell.activeConsumer.conditions;

export const conditionsDataSelector = createSelector(conditionsSelector, c => c.data);
export const conditionsDataErrorSelector = createSelector(conditionsSelector, c => c.errors.data);
export const conditionsDataLoadingSelector = createSelector(
  conditionsSelector,
  c => c.loading.data
);

export const conditionsActionLoadingSelector = createSelector(
  conditionsSelector,
  c => c.loading.action
);
export const conditionsActionErrorSelector = createSelector(
  conditionsSelector,
  c => c.errors.action
);
